import type { FC } from "react";
import styled from "styled-components";
import "@nectary/components/text";

const UsageTextContainer = styled.div`
  padding: 8px 0 8px 16px;
`;

type UsageInfoProps = {
  usageInfo: string;
};
export const UsageInfo: FC<UsageInfoProps> = ({ usageInfo }) => (
  <UsageTextContainer>
    <sinch-text emphasized type="m">
      {usageInfo}
    </sinch-text>
  </UsageTextContainer>
);
